<template>
  <b-container class="mh-100 h-100 d-flex flex-column overflow-auto">
    <b-row
      class="justify-content-center"
    >
      <b-col
        cols="auto"
        class="d-flex flex-column"
        :class="{'align-items-center': !isBubbles}"
      >
        <b-img
          :src="OrbVizLogoHorizontal"
          class="w-100"
        />
        <template v-if="isBubbles">
          <h5 class="not-found-message">
            Under construction
          </h5>
          <p>
            The owner of this OrbViz website has not published any content yet. Please check back later!
          </p>
          <b-button
            class="ml-auto"
            size="sm"
            :href="studioUrl"
          >
            Go to OrbViz Studio
          </b-button>
        </template>
        <template v-else>
          <h5>
            Error loading version
          </h5>
          <b-button
            variant="outline-secondary"
            :href="studioUrl"
          >
            Go to OrbViz Studio
          </b-button>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import OrbVizLogoHorizontal from '@/assets/imgs/orbicaLogo/Orbviz Logo Horizontal.png'
import { goToStudio } from '@/constants'

@Component
export default class NotFoundView extends Vue {
  OrbVizLogoHorizontal = OrbVizLogoHorizontal

  get studioUrl () {
    return goToStudio(this.$typedStore.currentRoute.primaryAppId)
  }

  get bubblesUrl () {
    return process.env.VUE_APP_BUBBLES_URL
  }

  get isBubbles () {
    return window.location.origin === this.bubblesUrl
  }
}
</script>
